(function () {
    'use strict';

    angular.module('app', [
        // Angular modules 
        'ngRoute',
        'ngMessages',
        'ngSanitize',
        'ngAnimate',

        // Custom modules 
        'chilliAuth',
        'pdfEdit',

        // 3rd Party Modules
        'ngMaterial',
        'as.sortable',
        'colorpicker.module',
        'ui.bootstrap',
        'ui.tinymce',
        'ui.select',
        'lfNgMdFileInput',
        'mdPickers',
        'angular-uuid',
        'ngFileUpload',
        'luegg.directives', // angular-scroll-glue
        'treeControl', // angular-tree-control by Wix
        'monospaced.elastic' // angular-elastic
    ]);

    angular.module('app').config(function ($compileProvider) {
        $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|file|blob)/);
    });

    angular.module('app').config(function ($mdIconProvider) {
        $mdIconProvider.defaultIconSet('/fonts/mdi.svg');
        $mdIconProvider.icon('email-received', '/fonts/email-received.svg');
        $mdIconProvider.icon('email-multiple', '/fonts/email-multiple.svg');
        $mdIconProvider.icon('email-sent', '/fonts/email-sent.svg');
        $mdIconProvider.icon('sms-sent', '/fonts/sms-sent.svg');
        $mdIconProvider.icon('comment-text-multiple', '/fonts/comment-text-multiple.svg');

        $mdIconProvider.icon('email-outline', '/fonts/email-outline.svg');
        $mdIconProvider.icon('comment-text-outline', '/fonts/comment-text-outline.svg');
        $mdIconProvider.icon('account-multiple-outline', '/fonts/account-multiple-outline.svg');
    });

    angular.module('app').config(function ($mdDateLocaleProvider) {
        $mdDateLocaleProvider.formatDate = function (date) {
            if (!angular.isUndefined(date) && date !== null) {
                return moment(date).format('D/M/YYYY');
            } else {
                return null;
            }
        };

        $mdDateLocaleProvider.parseDate = function (dateString) {
            var m = moment(dateString, 'D/M/YYYY', true);
            return m.isValid() ? m.toDate() : new Date(NaN);
        };
    });

    angular.module('app').config(function ($provide) {
        $provide.decorator('$log', function ($delegate) {
            var originalError = $delegate.error;

            $delegate.error = function (message) {
                appInsights.trackException(message);
                originalError(message);
            };

            return $delegate;
        });
    });


    angular.module('app').config(addTimeZone);

    addTimeZone.$inject = ['$httpProvider'];

    function addTimeZone($httpProvider) {
        $httpProvider.interceptors.push('timeZoneHttpInterceptor');
    }

    angular.module('app').factory('timeZoneHttpInterceptor', TimeZoneHttpInterceptor);

    TimeZoneHttpInterceptor.$inject = [];

    function TimeZoneHttpInterceptor() {
        return {
            request: function (config) {
                // Add time offset (in minutes) to every outgoing HTTP request so the server knows
                // what time the client has.
                config.headers = config.headers || {};
                config.headers['x-chilli-timeoffset'] = moment().utcOffset();
                return config;
            }
        };
    }


    angular.module('app').run(function ($rootScope, $location) {
        $rootScope.$on('$locationChangeSuccess', function (event, newLocation) {
            appInsights.trackPageView($location.path(), newLocation);
        });
    });

    angular.module('app').run(function ($rootScope, $window, WindowTitleService) {
        $rootScope.$on('$routeChangeSuccess', function () {
            WindowTitleService.setTitle();
            $window.scrollTo(0, 0);
        });
    });

    angular.module('app').run(function (NavigationAidService) { });
})();